import { useState } from "react";
import {
  RouterProvider,
  createMemoryHistory,
  createRouter,
} from "@tanstack/react-router";
import { QueryClient } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";

export default function FaultsApp() {
  const [router] = useState(() => {
    const queryClient = new QueryClient();

    return createRouter({
      routeTree,
      context: { queryClient },
      history: createMemoryHistory({
        initialEntries: ["/"],
      }),
      scrollRestoration: true,
      defaultPreloadStaleTime: 0,
    });
  });

  return <RouterProvider router={router} />;
}
